import { render, staticRenderFns } from "./DuplicateCandidateResolve.vue?vue&type=template&id=14b61f2c&scoped=true&"
import script from "./DuplicateCandidateResolve.vue?vue&type=script&lang=js&"
export * from "./DuplicateCandidateResolve.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateCandidateResolve.vue?vue&type=style&index=0&id=14b61f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b61f2c",
  null
  
)

export default component.exports